export const personTypes = [
  { label: 'Person', value: 'person' },
  { label: 'Company', value: 'company' },
]

export const personPopularity = [
  { label: 'True', value: true },
  { label: 'False', value: false },
]
export const GOATFilter = [
  { label: 'True', value: true },
]
export const personFilterOptions = [
  { label: 'Name En', value: 'name_En' },
  { label: 'Name Te', value: 'name_Te' },
  { label: 'About En', value: 'about_En' },
  { label: 'About Te', value: 'about_Te' },
  { label: 'Almamater En', value: 'almamater_En' },
  { label: 'Almamater Te', value: 'almamater_Te' },
  { label: 'Awards En', value: 'awards_En' },
  { label: 'Awards Te', value: 'awards_Te' },
  { label: 'BirthName En', value: 'birthName_En' },
  { label: 'BirthName Te', value: 'birthName_Te' },
  { label: 'Children En', value: 'children_En' },
  { label: 'Children Te', value: 'children_Te' },
  { label: 'Constituency En', value: 'constituency_En' },
  { label: 'Constituency Te', value: 'constituency_Te' },
  { label: 'ContentType', value: 'contentType' },
  { label: 'CurrentlyActive', value: 'currentlyActive' },
  { label: 'DateOfBirth', value: 'dateOfBirth' },
  { label: 'Died', value: 'died' },
  { label: 'education En', value: 'education_En' },
  { label: 'education Te', value: 'education_Te' },
  { label: 'family En', value: 'family_En' },
  { label: 'family Te', value: 'family_Te' },
  { label: 'genres En', value: 'genres_En' },
  { label: 'genres Te', value: 'genres_Te' },
  { label: 'honours En', value: 'honours_En' },
  { label: 'honours Te', value: 'honours_Te' },
  { label: 'instruments En', value: 'instruments_En' },
  { label: 'instrument Te', value: 'instrument_Te' },
  { label: 'labels En', value: 'labels_En' },
  { label: 'labels Te', value: 'labels_Te' },
  { label: 'memberOf En', value: 'memberOf_En' },
  { label: 'memberOf Te', value: 'memberOf_Te' },
  { label: 'name En', value: 'name_En' },
  { label: 'name Te', value: 'name_Te' },
  { label: 'nationality', value: 'nationality' },
  { label: 'nickName En', value: 'nickName_En' },
  { label: 'nickName Te', value: 'nickName_Te' },
  { label: 'notableWork En', value: 'notableWork_En' },
  { label: 'notableWork Te', value: 'notableWork_Te' },
  { label: 'occupation En', value: 'occupation_En' },
  { label: 'occupation Te', value: 'occupation_Te' },
  { label: 'origin En', value: 'origin_En' },
  { label: 'origin Te', value: 'origin_Te' },
  { label: 'otherNames En', value: 'otherNames_En' },
  { label: 'otherNames Te', value: 'otherNames_Te' },
  { label: 'otherPoliticalAffiliations En', value: 'otherPoliticalAffiliations_En' },
  { label: 'otherPoliticalAffiliations Te', value: 'otherPoliticalAffiliations_Te' },
  { label: 'parents En', value: 'parents_En' },
  { label: 'parents Te', value: 'parents_Te' },
  { label: 'personWikiURL', value: 'personWikiURL' },
  { label: 'placeOfBirth En', value: 'placeOfBirth_En' },
  { label: 'placeOfBirth Te', value: 'placeOfBirth_Te' },
  { label: 'politicalParty En', value: 'politicalParty_En' },
  { label: 'politicalParty Te', value: 'politicalParty_Te' },
  { label: 'posterURL', value: 'posterURL' },
  { label: 'precededBy En', value: 'precededBy_En' },
  { label: 'precededBy Te', value: 'precededBy_Te' },
  { label: 'relatives En', value: 'relatives_En' },
  { label: 'relatives Te', value: 'relatives_Te' },
  { label: 'residence En', value: 'residence_En' },
  { label: 'residence Te', value: 'residence_Te' },
  { label: 'spouse En', value: 'spouse_En' },
  { label: 'spouse Te', value: 'spouse_Te' },
  { label: 'succeededBy En', value: 'succeededBy_En' },
  { label: 'succeededBy Te', value: 'succeededBy_Te' },
  { label: 'title En', value: 'title_En' },
  { label: 'title Te', value: 'title_Te' },
  { label: 'website', value: 'website' },
  { label: 'works En', value: 'works_En' },
  { label: 'works Te', value: 'works_Te' },
  { label: 'yearsActive', value: 'yearsActive' },
]
export const personStatusOptions = [
  { label: 'Published', value: 'published' },
  { label: 'Draft', value: 'draft' },
  // { label: 'delete', value: 'deleted' },
]
export const filterAndResetButton = {
  main: {
    width: '5rem',
    height: '2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}
